var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplyActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6665 5.9325H10.3332",
    stroke: "#FFB446",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6665 8.599H8.50036",
    stroke: "#FFB446",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66658 12.4295H7.33325L10.2999 14.4028C10.7399 14.6962 11.3333 14.3828 11.3333 13.8495V12.4295C13.3333 12.4295 14.6666 11.0962 14.6666 9.09615V5.09615C14.6666 3.09615 13.3333 1.76282 11.3333 1.76282H4.66658C2.66659 1.76282 1.33325 3.09615 1.33325 5.09615V9.09615C1.33325 11.0962 2.66659 12.4295 4.66658 12.4295Z",
    stroke: "#FFB446",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyActive);
export default __webpack_public_path__ + "static/media/reply-active.a7087d654216032ce3ea13ac6e5d9207.svg";
export { ForwardRef as ReactComponent };